<template>
	<div>
		<label>
			<i
				v-if="labelInformacao"
				style="font-size: 12px"
				v-tooltip="labelInformacao"
				class="fa fa-info-circle"
				aria-hidden="true"
			></i>
			{{ label }}
		</label>
		<div style="position: relative">
			<i class="fa fa-search icone-busca" aria-hidden="true"></i>

			<input
				type="text"
				:value="value"
				@input="$emit('input', $event.target.value)"
				class="form-control pesquisar-main-input"
				:placeholder="placeholder"
				:disabled="disabled"
			/>

			<a href="#" v-show="value" @click.prevent="$emit('limpar-filtro-busca')">
				<i class="fa fa-times icone-limpar" aria-hidden="true"></i>
			</a>
		</div>
	</div>
</template>
<script>
export default {
	name: 'InputSearch',

	props: {
		label: {
			type: String,
			required: false,
			default: ''
		},

		labelInformacao: {
			type: String,
			required: false,
			default: ''
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false
		},

		value: {
			required: false,
			default: ''
		},

		placeholder: {
			type: String,
			required: false,
			default: ''
		}
	}
}
</script>

<style scoped>
.icone-busca {
	position: absolute;
	top: 8px;
	left: 7px;
	color: #999;
	z-index: 0;
}

.icone-limpar {
	position: absolute;
	top: 8px;
	right: 7px;
	color: #999;
	z-index: 0;
}

.pesquisar-main-input {
	padding-left: 20px;
}
</style>